import TextAreaField from "@components/form/TextAreaField";

export default function ParagraphField({
  item,
  index,
  formData,
  handleChange,
}) {
  const hasValue = !!item.value?.trim();
  const isParagraphAnswer= item.isParagraphAnswer
  const hasOptions = Array.isArray(item.options) && item.options.length > 0;

  if (hasValue && !hasOptions && !isParagraphAnswer) {
    return (
      <div className="mb-6">
        <label className="block text-sm font-medium mb-2 text-gray-900">
          {item.question}
          {item.required && <span className="text-red-500">*</span>}
        </label>
        <div
          className={`text-gray-800 dark:text-white whitespace-pre-wrap ${
            item.question ? "pl-5" : ""
          }`}
        >
          {item.value}
        </div>
      </div>
    );
  }

  if (hasOptions) {
    return (
      <div className="mb-6">
        <label className="block text-sm font-medium mb-2 text-gray-900">
          {item.question}
          {item.required && <span className="text-red-500">*</span>}
        </label>
        <ul
          className={`list-disc list-outside pl-8 text-sm text-gray-900 dark:text-gray-300 space-y-2 ${
            item.question ? "pl-8" : ""
          }`}
        >
          {item.options.map((opt, idx) => (
            <li key={idx} className="whitespace-pre-line">
              {opt.value}
            </li>
          ))}
        </ul>
      </div>
    );
  }

  return (
    <TextAreaField
      label={item.question}
      required={item.required}
      value={formData[index].answer ||formData[index].value|| ""}
      onChange={(e) => handleChange(index, "answer", e.target.value)}
      placeholder="Write your answer here..."
    />
  );
}
